import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { PartImageUrl } from "@helpers/partImage";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { LogExport } from "@interfaces/logExport.interface";
import { Client } from "@interfaces/models/client.interface";
import { Project } from "@interfaces/project.interface";
import { ClientService } from "@services/client.service";
import { ExportLogService } from "@services/exportLog.service";
import { PartService } from "@services/part.service";
import { ProjectService } from "@services/project.service";
import { ProtectedGridService } from "@services/protectedGrid.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "parts-deleted",
	styleUrls: ["parts-deleted.css"],
	templateUrl: "parts-deleted.html"
})
export class PartsDeletedAdminComponent {
	canExportGrid = false;
	clients: Client[] = [];
	gridLoading = false;
	headerPrimaryButtons: AdminHeaderButton[] = [{ method: "viewParts", text: "View Parts" }];
	headerSecondaryButtons: AdminHeaderButton[] = [];
	itemType = "Part";
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	items: any[] = [];
	projects: Project[] = [];
	title: string;
	validationErrors: string[] = [];
	
	constructor(private router: Router, private toastService: ToastService, private itemService: PartService, private clientService: ClientService, private exportLogService: ExportLogService, private projectService: ProjectService, private protectedGridService: ProtectedGridService) {
		this.title = `Deleted ${this.itemType}s`;
		this.duplicatePart = this.duplicatePart.bind(this);
		this.viewRow = this.viewRow.bind(this);
		this.getItems();
		this.getClients();
		this.getProjects();
		this.checkGridExportPermissions();
	}

	addNewItem() {
		this.router.navigate([`${this.itemUrl}/create`]);
	}

	boolYesNo(cellInfo: any){		
		if(cellInfo.value === true)
		{
			return "YES";
		}
		else
		{
			return "NO";
		}
	}
	
	checkGridExportPermissions() {
		this.protectedGridService.canExport("Deleted Parts")
			.subscribe(
				(res: any) => {
					this.canExportGrid = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	duplicatePart(e: any) {
		if (confirm("Are you sure you wish to duplicate this part? You will be taken to it for editing.") === true)
		{
			this.itemService.duplicate(e.row.data.id)
				.subscribe(
					(res: any) => {
						this.toastService.success(this.itemType + " duplicated!");
						this.router.navigate([`${this.itemUrl}/${res.response.id}_edit`]);
					},
					(err) => {
						console.log(err);
						this.toastService.error("Something Went Wrong!");
					},
				);
		}
	}

	getClients() {
		this.clientService.getAll()
			.subscribe(
				(res: any) => this.clients = res.response.items,
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	getItems() {
		this.gridLoading = true;
		this.itemService.getDeleted()
			.subscribe(
				(res: any) => {
					this.items = res.response;
					this.gridLoading = false;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	// Shared with the tools grid so both show a part the same way.
	getPartImage(imageUrl: string) {
		return PartImageUrl(imageUrl);
	}

	getProjects() {
		this.projectService.getAll()
			.subscribe(
				(res: any) => this.projects = res.response.items,
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	logExport() {
		const logExport = new LogExport();
		logExport.gridName = "Deleted Parts";
		this.exportLogService.logExport(logExport)
			.subscribe(
				() => console.log("Export Logged"),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
					return false;
				},
			);
	}
	
	onRowPrepared(e: any) {
		if (e.rowType === "data") {  
			if (e.data.needsCompleting === true)  {
				e.rowElement.classList.add("needsCompleting");
				e.rowElement.style.backgroundColor = "#ffd2ad";  
				e.rowElement.className = e.rowElement.className.replace("dx-row-alt", "");
			}
		}  
	}

	viewParts() {
		this.router.navigate([`${this.itemUrl}`]);
	}

	viewRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.id}`]);
	}
}